module.exports = __webpack_public_path__ + "static/media/23.40cc8007.jpg";